import { useMemo, type ReactNode } from 'react'
import { Select } from '@mantine/core'
import { translateLabels, useTranslation } from '@front/model'

type GranularitySelectorProps = {
  value: number
  onChange: (granularity: number) => void
  disabled?: boolean
}

export const GranularitySelector = ({ value, onChange, disabled }: GranularitySelectorProps): ReactNode => {
  const { t } = useTranslation()

  const handleSelectChange = (newValue: string | null): void => {
    if (!newValue) return
    const value = Number(newValue)
    if (isNaN(value)) return
    onChange(value)
  }

  const options = useMemo(() => {
    if (GRANULARITY_OPTIONS.some((option) => option.value === value.toString())) return GRANULARITY_OPTIONS
    return [...GRANULARITY_OPTIONS, { value: value.toString(), label: `Custom (${value} minutes)` }]
  }, [value])

  return (
    <Select
      label={t('Granularity')}
      description={t('The interval between available timeslots')}
      placeholder={t('Select granularity')}
      data={translateLabels(options, t)}
      value={value.toString()}
      onChange={handleSelectChange}
      disabled={disabled}
      flex={1}
    />
  )
}

const GRANULARITY_OPTIONS = [
  { value: '15', label: '15 minutes' },
  { value: '30', label: '30 minutes' },
  { value: '45', label: '45 minutes' },
  { value: '60', label: '1 hour' },
]
